import { useEffect } from 'react';
import { Control, Controller, useWatch, UseFormSetValue } from 'react-hook-form';
import { Select } from '@bizzabo/design-system';
import { usePrevious } from 'react-use';
import states from '../../helpers/states';
import type { EditFormValues } from '../../hooks';

const CountryStateDropdown = ({
    control,
    setValue,
}: {
    control: Control<EditFormValues>;
    setValue: UseFormSetValue<EditFormValues>;
}) => {
    const selectedCountry = useWatch({
        control,
        name: 'country',
    });

    const previousSelectedCountry = usePrevious(selectedCountry);

    useEffect(() => {
        if (previousSelectedCountry && previousSelectedCountry?.value !== selectedCountry?.value) {
            setValue('state', null);
        }
    }, [selectedCountry, previousSelectedCountry]);

    const isCountryStateEnabled = Object.keys(states)?.includes(selectedCountry?.value);

    return (
        <Controller
            name="state"
            control={control}
            render={({ field: { ref: _ref, ...selectProps } }) => (
                <Select
                    label="State"
                    options={states[selectedCountry?.value]}
                    isDisabled={!isCountryStateEnabled}
                    {...selectProps}
                />
            )}
        />
    );
};

export default CountryStateDropdown;
